export default [
  {
    level: 1,
    xp: 0,
    reward_points: 0,
  },
  {
    level: 2,
    xp: 8,
    reward_points: 1000,
  },
  {
    level: 3,
    xp: 24,
    reward_points: 1000,
  },
  {
    level: 4,
    xp: 56,
    reward_points: 1000,
  },
  {
    level: 5,
    xp: 106,
    reward_points: 1000,
  },
  {
    level: 6,
    xp: 170,
    reward_points: 1000,
  },
  {
    level: 7,
    xp: 235,
    reward_points: 1000,
  },
  {
    level: 8,
    xp: 301,
    reward_points: 1000,
  },
  {
    level: 9,
    xp: 368,
    reward_points: 1000,
  },
  {
    level: 10,
    xp: 436,
    reward_points: 1000,
  },
  {
    level: 11,
    xp: 506,
    reward_points: 1000,
  },
  {
    level: 12,
    xp: 578,
    reward_points: 1000,
  },
  {
    level: 13,
    xp: 652,
    reward_points: 1000,
  },
  {
    level: 14,
    xp: 728,
    reward_points: 1000,
  },
  {
    level: 15,
    xp: 806,
    reward_points: 1000,
  },
  {
    level: 16,
    xp: 886,
    reward_points: 1000,
  },
  {
    level: 17,
    xp: 968,
    reward_points: 1000,
  },
  {
    level: 18,
    xp: 1052,
    reward_points: 1000,
  },
  {
    level: 19,
    xp: 1138,
    reward_points: 1000,
  },
  {
    level: 20,
    xp: 1226,
    reward_points: 1000,
  },
  {
    level: 21,
    xp: 1315,
    reward_points: 1000,
  },
  {
    level: 22,
    xp: 1405,
    reward_points: 1000,
  },
  {
    level: 23,
    xp: 1496,
    reward_points: 1000,
  },
  {
    level: 24,
    xp: 1588,
    reward_points: 1000,
  },
  {
    level: 25,
    xp: 1681,
    reward_points: 1000,
  },
  {
    level: 26,
    xp: 1775,
    reward_points: 1000,
  },
  {
    level: 27,
    xp: 1870,
    reward_points: 1000,
  },
  {
    level: 28,
    xp: 1966,
    reward_points: 1000,
  },
  {
    level: 29,
    xp: 2063,
    reward_points: 1000,
  },
  {
    level: 30,
    xp: 2161,
    reward_points: 1000,
  },
  {
    level: 31,
    xp: 2260,
    reward_points: 1000,
  },
  {
    level: 32,
    xp: 2360,
    reward_points: 1000,
  },
  {
    level: 33,
    xp: 2461,
    reward_points: 1000,
  },
  {
    level: 34,
    xp: 2563,
    reward_points: 1000,
  },
  {
    level: 35,
    xp: 2666,
    reward_points: 1000,
  },
  {
    level: 36,
    xp: 2770,
    reward_points: 1000,
  },
  {
    level: 37,
    xp: 2875,
    reward_points: 1000,
  },
  {
    level: 38,
    xp: 2981,
    reward_points: 1000,
  },
  {
    level: 39,
    xp: 3088,
    reward_points: 1000,
  },
  {
    level: 40,
    xp: 3196,
    reward_points: 1000,
  },
  {
    level: 41,
    xp: 3305,
    reward_points: 1000,
  },
  {
    level: 42,
    xp: 3415,
    reward_points: 1000,
  },
  {
    level: 43,
    xp: 3526,
    reward_points: 1000,
  },
  {
    level: 44,
    xp: 3638,
    reward_points: 1000,
  },
  {
    level: 45,
    xp: 3751,
    reward_points: 1000,
  },
  {
    level: 46,
    xp: 3865,
    reward_points: 1000,
  },
  {
    level: 47,
    xp: 3980,
    reward_points: 1000,
  },
  {
    level: 48,
    xp: 4096,
    reward_points: 1000,
  },
  {
    level: 49,
    xp: 4213,
    reward_points: 1000,
  },
  {
    level: 50,
    xp: 4331,
    reward_points: 1000,
  },
  {
    level: 51,
    xp: 4450,
    reward_points: 1000,
  },
  {
    level: 52,
    xp: 4570,
    reward_points: 1000,
  },
  {
    level: 53,
    xp: 4691,
    reward_points: 1000,
  },
  {
    level: 54,
    xp: 4813,
    reward_points: 1000,
  },
  {
    level: 55,
    xp: 4936,
    reward_points: 1000,
  },
  {
    level: 56,
    xp: 5060,
    reward_points: 1000,
  },
  {
    level: 57,
    xp: 5185,
    reward_points: 1000,
  },
  {
    level: 58,
    xp: 5311,
    reward_points: 1000,
  },
  {
    level: 59,
    xp: 5438,
    reward_points: 1000,
  },
  {
    level: 60,
    xp: 5566,
    reward_points: 1000,
  },
  {
    level: 61,
    xp: 5695,
    reward_points: 1000,
  },
  {
    level: 62,
    xp: 5825,
    reward_points: 1000,
  },
  {
    level: 63,
    xp: 5956,
    reward_points: 1000,
  },
  {
    level: 64,
    xp: 6088,
    reward_points: 1000,
  },
  {
    level: 65,
    xp: 6221,
    reward_points: 1000,
  },
  {
    level: 66,
    xp: 6355,
    reward_points: 1000,
  },
  {
    level: 67,
    xp: 6490,
    reward_points: 1000,
  },
  {
    level: 68,
    xp: 6626,
    reward_points: 1000,
  },
  {
    level: 69,
    xp: 6763,
    reward_points: 1000,
  },
  {
    level: 70,
    xp: 6901,
    reward_points: 1000,
  },
  {
    level: 71,
    xp: 7040,
    reward_points: 1000,
  },
  {
    level: 72,
    xp: 7180,
    reward_points: 1000,
  },
  {
    level: 73,
    xp: 7321,
    reward_points: 1000,
  },
  {
    level: 74,
    xp: 7463,
    reward_points: 1000,
  },
  {
    level: 75,
    xp: 7606,
    reward_points: 1000,
  },
  {
    level: 76,
    xp: 7750,
    reward_points: 1000,
  },
  {
    level: 77,
    xp: 7895,
    reward_points: 1000,
  },
  {
    level: 78,
    xp: 8041,
    reward_points: 1000,
  },
  {
    level: 79,
    xp: 8188,
    reward_points: 1000,
  },
  {
    level: 80,
    xp: 8336,
    reward_points: 1000,
  },
  {
    level: 81,
    xp: 8485,
    reward_points: 1000,
  },
  {
    level: 82,
    xp: 8635,
    reward_points: 1000,
  },
  {
    level: 83,
    xp: 8786,
    reward_points: 1000,
  },
  {
    level: 84,
    xp: 8938,
    reward_points: 1000,
  },
  {
    level: 85,
    xp: 9091,
    reward_points: 1000,
  },
  {
    level: 86,
    xp: 9245,
    reward_points: 1000,
  },
  {
    level: 87,
    xp: 9400,
    reward_points: 1000,
  },
  {
    level: 88,
    xp: 9556,
    reward_points: 1000,
  },
  {
    level: 89,
    xp: 9713,
    reward_points: 1000,
  },
  {
    level: 90,
    xp: 9871,
    reward_points: 1000,
  },
  {
    level: 91,
    xp: 10030,
    reward_points: 1000,
  },
  {
    level: 92,
    xp: 10190,
    reward_points: 1000,
  },
  {
    level: 93,
    xp: 10351,
    reward_points: 1000,
  },
  {
    level: 94,
    xp: 10513,
    reward_points: 1000,
  },
  {
    level: 95,
    xp: 10676,
    reward_points: 1000,
  },
  {
    level: 96,
    xp: 10840,
    reward_points: 1000,
  },
  {
    level: 97,
    xp: 11005,
    reward_points: 1000,
  },
  {
    level: 98,
    xp: 11171,
    reward_points: 1000,
  },
  {
    level: 99,
    xp: 11338,
    reward_points: 1000,
  },
];
